// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1c2Yz","messages":"Chat_messages__26JyM","dateDivider":"Chat_dateDivider__3H_RL"};